import React from "react";
import { createPortal } from "react-dom";

const AddYachtModal = ({
    show,
    onClose,
    newYacht,
    handleInputChange,
    handleSubmit,
    isSubmitting,
    formErrors,
    dragActive,
    handleDrag,
    handleDrop,
    handleFileChange,
    imageUploading,
    removeImage,
    imageDescriptions,
    handleImageDescriptionChange,
}) => {
    if (!show) {
        return null;
    }

    const modalContent = (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 overflow-y-auto">
            <div className="bg-gray-800/95 backdrop-blur-md rounded-2xl w-full max-w-4xl my-8 border border-white/10 shadow-2xl shadow-black/50">
                <div className="sticky top-0 z-10 bg-gray-800/95 backdrop-blur-md rounded-t-2xl border-b border-white/10 px-8 py-6">
                    <div className="flex justify-between items-center">
                        <div>
                            <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">Yeni Yat Ekle</h2>
                            <p className="text-sm text-white/50 mt-1">Yat bilgilerini eksiksiz doldurun</p>
                        </div>
                        <button
                            disabled={isSubmitting}
                            onClick={onClose}
                            className="p-2 bg-white/5 text-white/60 rounded-xl hover:bg-red-500/20 hover:text-red-400 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed group"
                        >
                            <svg
                                className="w-6 h-6 transition-transform group-hover:rotate-90 duration-300"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                </div>

                <form
                    onSubmit={handleSubmit}
                    className={`px-8 py-6 ${
                        isSubmitting ? "pointer-events-none opacity-75" : ""
                    }`}
                >
                    <div className="grid grid-cols-2 gap-6 mb-6">
                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Yat Adı
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={newYacht.name}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                    formErrors.name
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                placeholder="Örn: Azimut 55"
                                required
                            />
                            {formErrors.name && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.name}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Kaptan Adı
                            </label>
                            <input
                                type="text"
                                name="captain"
                                value={newYacht.captain}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                    formErrors.captain
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                placeholder="Örn: Mehmet Yılmaz"
                                required
                            />
                            {formErrors.captain && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.captain}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Yat Tipi
                            </label>
                            <select
                                name="type"
                                value={newYacht.type}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white focus:outline-none transition-all duration-300 ${
                                    formErrors.type
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                required
                            >
                                <option value="" disabled>
                                    Yat tipi seçin
                                </option>
                                <option value="1">Motor Yacht</option>
                                <option value="2">Sailing Yacht</option>
                                <option value="3">Catamaran</option>
                                <option value="4">Luxury Yacht</option>
                                <option value="5">Super Yacht</option>
                            </select>
                            {formErrors.type && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.type}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Kapasite (Kişi)
                            </label>
                            <input
                                type="number"
                                name="capacity"
                                value={newYacht.capacity}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                    formErrors.capacity
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                placeholder="Örn: 12"
                                min="1"
                                required
                            />
                            {formErrors.capacity && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.capacity}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Model
                            </label>
                            <input
                                type="text"
                                name="model"
                                value={newYacht.model}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                    formErrors.model
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                placeholder="Örn: Azimut"
                                required
                            />
                            {formErrors.model && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.model}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Üretim Yılı
                            </label>
                            <input
                                type="number"
                                name="year"
                                value={newYacht.year}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                    formErrors.year
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                placeholder="Örn: 2020"
                                min="1900"
                                max={new Date().getFullYear()}
                                required
                            />
                            {formErrors.year && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.year}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Uzunluk (Metre)
                            </label>
                            <input
                                type="number"
                                name="length"
                                value={newYacht.length}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                    formErrors.length
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                placeholder="Örn: 16.5"
                                step="0.1"
                                min="1"
                                required
                            />
                            {formErrors.length && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.length}
                                </p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-white/80 mb-2">
                                Günlük Kiralama Fiyatı (₺)
                            </label>
                            <input
                                type="number"
                                name="price"
                                value={newYacht.price}
                                onChange={handleInputChange}
                                className={`w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/30 focus:outline-none transition-all duration-300 ${
                                    formErrors.price
                                        ? "border-red-500 focus:border-red-500"
                                        : "border-white/10 focus:border-blue-500"
                                }`}
                                placeholder="Örn: 1500"
                                step="100"
                                min="0"
                                required
                            />
                            {formErrors.price && (
                                <p className="text-red-400 text-sm mt-1">
                                    {formErrors.price}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* Resim Yükleme Alanı */}
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-white/80 mb-3">
                            Yat Resimleri
                            <span className="text-white/50 text-xs ml-2">
                                (En fazla 10 resim, maksimum 5MB)
                            </span>
                        </label>

                        {/* Drag & Drop Alanı */}
                        <div
                            className={`relative border-2 border-dashed rounded-xl p-8 text-center transition-all duration-300 ${
                                dragActive
                                    ? "border-blue-500 bg-blue-500/10"
                                    : "border-white/20 hover:border-white/40"
                            } ${
                                imageUploading
                                    ? "opacity-50 pointer-events-none"
                                    : ""
                            }`}
                            onDragEnter={handleDrag}
                            onDragLeave={handleDrag}
                            onDragOver={handleDrag}
                            onDrop={handleDrop}
                        >
                            <input
                                type="file"
                                multiple
                                accept="image/*"
                                onChange={handleFileChange}
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                disabled={imageUploading}
                            />

                            <div className="flex flex-col items-center">
                                <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mb-4">
                                    {imageUploading ? (
                                        <div className="animate-spin rounded-full h-6 w-6 border-2 border-blue-400 border-t-transparent"></div>
                                    ) : (
                                        <svg
                                            className="w-6 h-6 text-blue-400"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                            />
                                        </svg>
                                    )}
                                </div>
                                <p className="text-white/80 mb-2">
                                    {imageUploading
                                        ? "Resimler yükleniyor..."
                                        : dragActive
                                        ? "Resimleri buraya bırakın"
                                        : "Resimleri sürükleyip bırakın veya tıklayın"}
                                </p>
                                <p className="text-white/50 text-sm">
                                    JPG, PNG, WebP formatları desteklenir
                                </p>
                            </div>
                        </div>

                        {/* Yüklenen Resimler */}
                        {newYacht.images.length > 0 && (
                            <div className="mt-4">
                                <p className="text-sm text-white/80 mb-3">
                                    Yüklenen Resimler ({newYacht.images.length}
                                    /10)
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-96 overflow-y-auto">
                                    {newYacht.images.map((image) => (
                                        <div
                                            key={image.id}
                                            className="bg-white/5 rounded-lg p-4 border border-white/10"
                                        >
                                            <div className="relative group mb-3">
                                                <img
                                                    src={image.preview}
                                                    alt={image.name}
                                                    className="w-full h-32 object-cover rounded-lg"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        removeImage(image.id)
                                                    }
                                                    className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-red-600"
                                                    title="Resmi sil"
                                                >
                                                    <svg
                                                        className="w-3 h-3"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M6 18L18 6M6 6l12 12"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                            
                                            <div className="space-y-2">
                                                <p
                                                    className="text-xs text-white/60 truncate font-medium"
                                                    title={image.name}
                                                >
                                                    {image.name}
                                                </p>
                                                <p className="text-xs text-white/40">
                                                    {(
                                                        image.size /
                                                        1024 /
                                                        1024
                                                    ).toFixed(2)}{" "}
                                                    MB
                                                </p>
                                                
                                                {/* Description input field */}
                                                <div>
                                                    <label className="block text-xs text-white/70 mb-1 font-medium">
                                                        Resim Açıklaması
                                                    </label>
                                                    <textarea
                                                        value={imageDescriptions[image.id] || ''}
                                                        onChange={(e) => handleImageDescriptionChange(image.id, e.target.value)}
                                                        placeholder="Bu resim için açıklama... (opsiyonel)"
                                                        rows="2"
                                                        className="w-full px-3 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/40 focus:outline-none focus:border-blue-500 transition-all resize-none text-xs"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="sticky bottom-0 bg-gray-800/95 backdrop-blur-md border-t border-white/10 pt-6 -mx-8 px-8 pb-6 mt-6">
                        <div className="flex justify-end gap-3">
                            <button
                                type="button"
                                disabled={isSubmitting}
                                onClick={onClose}
                                className="px-6 py-3 bg-white/5 border border-white/10 rounded-xl text-white hover:bg-white/10 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                            >
                                İptal
                            </button>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 disabled:from-blue-400 disabled:to-blue-500 disabled:cursor-not-allowed shadow-lg shadow-blue-500/30 font-medium"
                            >
                                {isSubmitting ? (
                                    <div className="flex items-center gap-2">
                                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                                        <span>İşleniyor...</span>
                                    </div>
                                ) : (
                                    <div className="flex items-center gap-2">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                        </svg>
                                        <span>Yat Ekle</span>
                                    </div>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default AddYachtModal;
